/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"
import { JournalList, MapJournalList } from "../../types"
import { mapJournalList } from "../functions/mapJournalList"

type UseJournalList = {
  DataSource: number | string
  StartDate: string
  EndDate: string
  onSuccess?: (data: MapJournalList[]) => void
}

type Response = {
  payload: JournalList[]
}

export function useJournalList({
  DataSource,
  StartDate,
  EndDate,
  onSuccess
}: UseJournalList) {
  const api = useApi()
  const [data, setData] = useState<MapJournalList[]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    // params inventory mengirim string
    api
      .postForm("/journal/getjournaldata", { StartDate, EndDate, DataSource: (DataSource === 21 ? "14,22,24,27,36,37" : DataSource) })
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? []
        const mapData = mapJournalList(data).sort((a, b) => b.date.localeCompare(a.date))

        onSuccess?.(mapData)
        setData(mapData)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    if (StartDate && EndDate) {
      fetchData()
    }

    return () => {
      setData([])
      setLoading(false)
    }
  }, [StartDate, EndDate, DataSource])

  return { data, isLoading, refetch }
}
